/**
 * 任务模块API
 */
import http from './http'

class WelfareApi {
    static getOneWelfare() {
        return http.httpPost('welfare/getOneWelfare');
    }

    static isFinishTask(taskId) {
        return http.httpGet('welfare/isFinishTask', {taskId});
    }

    static canFinishTask(taskId) {
        return http.httpGet('welfare/canFinishTask', {taskId});
    }

    static finishTask(params) {
        return http.httpPost('welfare/finishTask', params);
    }
    static welfareList(params) {
        return http.httpGet('welfare/list', params);
    }
    static getTypeWelfare(params) {
        return http.httpPost('welfare/getTypeWelfare', params);
    }
    static getShareList(params) {
        return http.httpPost('welfare/getShareList', params);
    }
    static getLogList(params) {
        return http.httpPost('welfareLog/getLogList', params);
    }
    static updateLog(params) {
        return http.httpPost('welfareLog/updateLog', params);
    }
    static getWordLog(params) {
        return http.httpPost('welfare/getWordLog', params);
    }
    static addLog(params) {
        return http.httpPost('welfareLog/addLog', params);
    }
    static addShareLog(params) {
        return http.httpPost('shareLog/addShareLog', params);
    }
    static getTypeLog(params) {
        return http.httpPost('welfare/getTypeLog', params);
    }


}

export default WelfareApi;



// WEBPACK FOOTER //
// ./app/api/welfare.api.js